<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRiskGiris from "@/models/StrRiskGiris";
import formdate from "@/router/views/FormComponet/formdate.vue";
import Swal from "sweetalert2";
import AddEdit from "./RiskKontrolAdd.vue";
import moment from "moment"; 
export default {
  mixins: [Api, Sabit, StrRiskGiris],
  props: ["Id", "AddEdit", "Donem" , "AltDonem", "BirimId", "Sayac"],
  data() {
    return {
      FormData: {},
      Kontrol_Turu: null,
      DataUpdate: null,
      AddEditCevap: null,
      AddEditGiris: null,
      GirisId: "",
      YonlendiriciEylem: [],
      OnleyiciEylem: [],
      DuzelticiEylem: [],
      SaptayiciEylem: [],
      OldGirisKontrol: [],
      OldKontroller: [],
      StrRiskDeger: [],
      EskiDonem: [],
      IlkDonem: true,
      EskiDonemBitTarih: null,
      Kontroller: false,
      Eylemler: [],
      EylemData: null,
      OldEylems: [],
      OldEylemOnay: 0,
    };
  },
  components: {
    Loader,
    forminput,
    formtextarea,
    AddEdit,
    formdate
  },
  watch: {

    Id() {
      this.IlkDonem = true
      this.GetWatch();

    },
    AltDonem() {
      this.GetWatch();
    },
    Sayac() {
      this.GetWatch();
    }

  },
  methods: {
    KontrollerDel(Data) {
      this.Delete("StrRisklerGirislerCevap", Data.Id).then((res) => {
        if (res) {
          this.GetWatch();
        }

      })
    },
    async Yenile(){

await new Promise(resolve => setTimeout(resolve, 2000));
  this.FilterGet();
},
    EylemiKaldir(Data){
      Data.Durum = 1;
      this.Update("StrRisklerGirislerCevap", Data)
    },
    BirOncekiDonem(){

      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      }; 
      this.EskiDonem=[];
      this.ActionsSingleGet({
                Service: "strperfdonem",
                Id: this.AltDonem,
              }).then((res) => {
                this.EskiDonemBitTarih = (res.Data.YilBit - 1).toString(); 



      let Filter ="&UstId="+this.Donem+"&Approval=true&Asc=Aciklama"+"&Yilbit="+this.EskiDonemBitTarih+"&VeriTipi=3"
      this.ActionsFilterGet({Service:"StrPerfDonem", Page:Page,Filter:Filter}).then((res) => {
              this.EskiDonem = res.Data;
              if(res.Data.length > 0){
                this.IlkDonem = false;
              }else{
                this.IlkDonem = true;
              }


          
      }); 
      });
      },
    GetWatch() {
  
  
      this.BirOncekiDonem();
      let Page = {
        PageNumber: "1",
        PageSize: "9999"
      }
      this.ActionsFilterGet({ Service: "StrRiskDeger", Page: Page, Filter: "&RiskId=" + this.Id.Id + "&DonemId=" + this.AltDonem}).then((res) => {
            this.StrRiskDeger = res.Data;

        let KayitKontrol = null;
        this.ActionsFilterGet({ Service: "StrRiskGiris", Page: Page, Filter: "&RiskId=" + this.Id.Id + "&DonemId=" + this.AltDonem}).then((res) => {

        KayitKontrol = res.Data;

        if(this.IlkDonem == false){
          this.ActionsFilterGet({ Service: "StrRiskGiris", Page: Page, Filter: "&RiskId=" + this.Id.Id + "&DonemId=" + this.EskiDonem[0].Id}).then((res) => {
            this.OldGirisKontrol = res.Data;
            if(res.Data.length == 0){
              this.OldEylemOnay = -1;   // riskin veri girileceği ilk dönem (ilk risk dönemi değil)
            }else{
              this.ActionsFilterGet({ Service: "StrRisklerGirislerCevap", Page: Page, Filter: "&BirimId=" + this.BirimId + "&GirisId=" + res.Data[0].Id }).then((reseylem) => {
            this.OldEylems = reseylem.Data;
            this.OldEylemOnay = reseylem.Data[0].Onay

          });
          }});
        }    
        if (KayitKontrol[0] != null) {

          this.FormData = null;
          this.AddEdit = "Edit";
          this.FormData = KayitKontrol[0];

          this.FormData.BaslamaTarihi = moment(String(KayitKontrol[0].BaslamaTarihi)).format("YYYY-MM-DD");
          this.FormData.BitisTarihi = moment(String(KayitKontrol[0].BitisTarihi)).format("YYYY-MM-DD");
          this.ActionsFilterGet({ Service: "StrRisklerGirislerCevap", Page: Page, Filter: "&BirimId=" + this.BirimId + "&GirisId=" + this.FormData.Id + "&CevapTipi=2"}).then((resp) => {
            this.YonlendiriciEylem = resp.Data

          });
          this.ActionsFilterGet({ Service: "StrRisklerGirislerCevap", Page: Page, Filter: "&BirimId=" + this.BirimId + "&GirisId=" + this.FormData.Id + "&CevapTipi=3"}).then((resp) => {
            this.OnleyiciEylem = resp.Data

          });
          this.ActionsFilterGet({ Service: "StrRisklerGirislerCevap", Page: Page, Filter: "&BirimId=" + this.BirimId + "&GirisId=" + this.FormData.Id + "&CevapTipi=4"}).then((resp) => {
            this.DuzelticiEylem = resp.Data


          });
          this.ActionsFilterGet({ Service: "StrRisklerGirislerCevap", Page: Page, Filter: "&BirimId=" + this.BirimId + "&GirisId=" + this.FormData.Id + "&CevapTipi=5"}).then((resp) => {
            this.SaptayiciEylem = resp.Data

          });

          this.FormData.RiskPuani = this.RiskDegerFilterEtkiOlasilik(this.Id.Id).[2];
          this.FormData.Etki = this.RiskDegerFilterEtkiOlasilik(this.Id.Id).[0];
          this.FormData.Olasilik = this.RiskDegerFilterEtkiOlasilik(this.Id.Id).[1];


        } else {
          this.FormData = null;
          this.AddEdit = "Add";
          let değer = JSON.stringify(this.StrRiskGirisData);

          this.FormData = JSON.parse(değer);

          this.FormData.Risk = this.Id.Risk;
          this.FormData.RiskId = this.Id.Id;
          this.FormData.DonemId = this.AltDonem;
          this.FormData.RiskPuani = this.RiskDegerFilterEtkiOlasilik(this.Id.Id).[2];
          this.FormData.Etki = this.RiskDegerFilterEtkiOlasilik(this.Id.Id).[0];
          this.FormData.Olasilik = this.RiskDegerFilterEtkiOlasilik(this.Id.Id).[1];
          this.$delete(this.FormData, "Id");


        }
        this.EylemleriGetir2()
      });
      });

    },
    onSubmit() {


      if(this.OldEylemOnay == 1 || this.IlkDonem == true || this.OldEylemOnay == -1){

      this.$v.$touch();
      if (!this.$v.$invalid) {
        var FormData = this.FormData;
        if (this.BirimId != null && this.BirimId != "") { this.FormData.BirimId = this.BirimId }
        if (this.AddEdit == "Add") {
          this.FormData.DonemId = this.AltDonem;

          this.Post("StrRiskGiris", FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate", this.FormData);
              this.ActionsSingleGet({
                Service: "StrRiskGiris",
                Id: res.Data,
              }).then((res) => {
                this.FormData = res.Data;
                this.FormData.BaslamaTarihi = moment(String(this.FormData.BaslamaTarihi)).format("YYYY-MM-DD") 
                this.FormData.BitisTarihi = moment(String(this.FormData.BaslamaTarihi)).format("YYYY-MM-DD") 
                this.EylemData = [];
                this.YonlendiriciEylem = [];
                this.OnleyiciEylem = [];
                this.DuzelticiEylem = [];
                this.SaptayiciEylem = [];

            
              });

            }
          });

        } else {
          this.FormData.DonemId = this.AltDonem;
          this.Update("StrRiskGiris", FormData).then((res) => {

            if (res) {
              this.$emit("Update", this.FormData);
              this.$emit("TableUpdate", this.FormData);
              this.$bvModal.hide("StrRiskGiris");
              this.FormData = [];

            }

          });
        }

      }
      }else{
        this.$toast.error('Bir önceki dönem eylem planınız henüz onaylanmadığından değerlendirme işlemine devam edemezsiniz!');
      }
    },

    EylemleriGetir(){
      let Page = {
        PageNumber: "1",
        PageSize: "9999"
      }
      this.ActionsFilterGet({ Service: "StrRisklerGirislerCevap", Page: Page, Filter: "&BirimId=" + this.BirimId + "&GirisId=" + this.OldGirisKontrol[0].Id }).then((res) => {

        this.EylemleriEkle(res.Data)

          });
     
    },
    EylemleriEkle(OldKontroller){
      return Swal.fire({
        title: 'Önceki Dönem Eylemleri Eklensin Mi?',
        text: 'Önceki Dönem Eylemleri Eklensin Mi?',
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          for(var Data in OldKontroller){
          let FormData = {
            Deleted: false,
            GirisId: this.FormData.Id,
            BirimId: OldKontroller[Data].BirimId,
            Cevaptipi: OldKontroller[Data].Cevaptipi,
            Cevap: OldKontroller[Data].Cevap,
            BaslamaTarihi: OldKontroller[Data].BaslamaTarihi,
            BitisTarihi: OldKontroller[Data].BitisTarihi,
            Aciklama: "",
            Tamamlanma: 0,
            Durum: 0
          } 
          this.Post("StrRisklerGirislerCevap", FormData)
                
        }
        this.GetWatch();
        }
      });
    },
    Get() { },

    RiskDegerGirisFilter(RiskId, DonemId) {

      let Filter = this.StrRiskDegerGiris.filter(notification => notification.RiskId.includes(RiskId));

      Filter = Filter.filter(notification => notification.DonemId.includes(DonemId));

      if (Filter) { return Filter } else { return }
    },

    RiskDegerFilter(RiskId) {
      let Filter = this.StrRiskDeger.filter((notification) =>
        notification.Riskid.includes(RiskId)
      );
      Filter = Filter.filter((notification) =>
        notification.Donemid.includes(this.AltDonem)
      );

      let VeriUzunlugu = Filter.length;
      if (VeriUzunlugu > 0) {

        return Filter[0].Riskpuani;
      } else {
        return;
      }
    },

    RiskDegerFilterEtkiOlasilik(RiskId) {
      let Filter = this.StrRiskDeger.filter(notification => notification.Riskid.includes(RiskId));

      if (Filter.length > 0) {

        Filter = Filter.filter((notification) => notification.Donemid.includes(this.AltDonem));

        let Etki = 0;
        let Olasilik = 0;
        let Riskpuani = 0;
        let VeriUzunlugu = Filter.length
        if (VeriUzunlugu > 0) {
          Filter.forEach(Data => {
            Etki += Data.Etki
            Olasilik += Data.Olasilik
          })
          Etki = (Etki / VeriUzunlugu).toFixed(0)
          Olasilik = (Olasilik / VeriUzunlugu).toFixed(0)
          Riskpuani = Etki * Olasilik;
          return [Etki, Olasilik, Riskpuani]
        } else {
          return [0, 0, 0]
        }

      } else {

        return [0, 0, 0]
      }
    }
  },

};
</script>
<template>
  <Loader>
    <b-modal id="StrRiskGiris" size="lg" :title="this.AddEdit == 'Edit'
        ? $t('StrRiskGiris.AddEdit.FormTitleEdit')
        : $t('StrRiskGiris.AddEdit.FormTitleAdd')
      " title-class="font-18" hide-footer>


      <Form @submit.prevent="onSubmit">
        <formtextarea :FormDataType="FormDataType.Risk" :Value="FormData.Risk" :v="$v.FormData.Risk"
          @input="FormData.Risk = $event" />

        <forminput :FormDataType="FormDataType.RiskPuani" :Value="FormData.RiskPuani" :v="$v.FormData.RiskPuani"
          @input="FormData.RiskPuani = $event" />
          <div class="row">
        <div class="col-md-6">
          <formdate :FormDataType="FormDataType.BaslamaTarihi" :Value="FormData.BaslamaTarihi"
            :v="$v.FormData.BaslamaTarihi" @input="FormData.BaslamaTarihi = $event" />
        </div>
        <div class="col-md-6">
          <formdate :FormDataType="FormDataType.BitisTarihi" :Value="FormData.BitisTarihi" :v="$v.FormData.BitisTarihi"
            @input="FormData.BitisTarihi = $event" />
        </div>
        </div>
        <div class="table-responsive">
          <center>
            <h4>Riske Verilen Cevaplar</h4>
          </center>
          <hr>
          <table class="table table-striped ">
            <tr>
              <td v-for="Risk in RiskDurumlari" :key="Risk.Id">
                <b-form-group v-if="(Risk.Kod === '1' &&
                    FormData.RiskPuani < 25) ||
                  (Risk.Kod === '4' &&
                    FormData.RiskPuani >= 25) ||
                  (Risk.Kod === '2' &&
                    FormData.RiskPuani >= 25) ||
                  (Risk.Kod === '3' &&
                    FormData.RiskPuani >= 25)
                  " class="mb-3" id="example text" label-cols-lg="5" :label="Risk.Value" label-for="text">
                  <b-form-radio :class="{ 'is-invalid': $v.FormData.DurumId.$error }" class="mb-3" :value="Risk.Id" plain
                    v-model="FormData.DurumId"></b-form-radio>
                  <div v-if="$v.FormData.DurumId.$error" class="invalid-feedback">
                    <span v-if="!$v.FormData.DurumId.required">{{
                      $t("ValidationMessage.required")
                    }}</span>
                  </div>
                </b-form-group>
              </td>

            </tr>
          </table>


        </div>

        <center>
          <h4>Mevcut Kontroller</h4>
        </center>
        <hr>

        <div class="table-responsive">
          <table style="width: 100%;" class="table table-striped ">
            <tr>
              <!--  <td>

        <b-form-group
            class="mb-3"
            id="example text"
            label-cols-lg="5"
            label-for="text"
            label=" Mevcut Kontroller"
           
          >
         
            <b-form-radio
              class="mb-3"  
              :value="'1'"
              plain
              v-model="FormData.Kontrolturu"
            ></b-form-radio>

            </b-form-group>

            </td>-->

              <td>

                <b-form-group class="mb-3" id="example text" label-cols-lg="5" label-for="text"
                  label="Yönlendirici Kontroller">

                  <b-form-radio class="mb-3" :value="'2'" plain v-model="FormData.Kontrolturu"></b-form-radio>

                </b-form-group>
              </td>
              <td>
                <b-form-group class="mb-3" id="example text" label-cols-lg="5" label-for="text"
                  label="Önleyici Kontroller">

                  <b-form-radio class="mb-3" :value="'3'" plain v-model="FormData.Kontrolturu"></b-form-radio>

                </b-form-group>

              </td>

              <td>

                <b-form-group class="mb-3" id="example text" label-cols-lg="5" label-for="text"
                  label="Düzeltici Kontroller">

                  <b-form-radio class="mb-3" :value="'4'" plain v-model="FormData.Kontrolturu"></b-form-radio>

                </b-form-group>

              </td>

              <td>
                <b-form-group class="mb-3" id="example text" label-cols-lg="5" label-for="text"
                  label="Tespit Edici Kontroller">

                  <b-form-radio class="mb-3" :value="'5'" plain v-model="FormData.Kontrolturu"></b-form-radio>

                </b-form-group>

              </td>


            </tr>
          </table>
        </div>


        <!--  <formtextarea v-if="FormData.Kontrolturu==1"
          :FormDataType="FormDataType.MevcutKontroller"
          :Value="FormData.MevcutKontroller"
          :v="$v.FormData.MevcutKontroller"
          @input="FormData.MevcutKontroller = $event"
          :rows="5"
        /> -->
      <!--  <div v-if="FormData.Kontrolturu == 2">
        Yönlendirici Kontroller:  {{ FormData.YonlendiriciKontroller }}
        </div>
        <div v-if="FormData.Kontrolturu == 3">
        Önleyici Kontroller:  {{ FormData.OnleyiciKontroller }}
        </div>
        <div v-if="FormData.Kontrolturu == 4">
        Düzeltici Kontroller:  {{ FormData.DuzelticiKontroller }}
        </div>
        <div v-if="FormData.Kontrolturu == 5">
        Saptayıcı Kontroller:  {{ FormData.SaptayiciKontroller }}
        </div> -->

        <div v-if="FormData.Kontrolturu == 2 && (this.AddEdit=='Edit' || this.Kontroller == true)" class="row">
          <div class="col-md-7">
          </div>
          <div class="col-md-5">
          <b-button-group class="float-end">
            <b-button variant="success" v-b-modal.StrRisklerGirislerCevap @click="(AddEditCevap = 'Add'),(AddEditGiris = this.AddEdit)
              (GirisId = this.FormData.Id)">{{$t('StrRiskGiris.Table.EylemEkle')}}
            </b-button>
           <b-button variant="primary" v-if="this.IlkDonem==false" @click="EylemleriGetir()">Eylemleri Getir</b-button> 
          </b-button-group>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <div class="card">

                <table class="table table-striped table-bordered mb-0">
                  <thead>
                    <tr>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.Eylem')}}</th>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.BaslamaTarihi')}}</th>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.BitisTarihi')}}</th>
                      <th scope="col-2" style="text-align: center;">{{$t('StrRiskGiris.Table.Islem')}}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(Data, index) in this.YonlendiriciEylem" :key="index">
                    <tr  v-if="Data.Durum != 1">
                      <td scope="col-9">  {{ Data.Cevap }}</td>
                      <td scope="col-9">  {{ Data.BaslamaTarihi | formatDateTable}}</td>
                      <td scope="col-9">  {{ Data.BitisTarihi | formatDateTable}}</td>
                      <td style="text-align: center;" scope="col-3">
                        <b-button-group >
                          <b-button variant="success" v-b-modal.StrRisklerGirislerCevap @click="(AddEditCevap = 'Edit'),(EylemData = Data),(AddEditGiris = this.AddEdit),(GirisId = this.FormData.Id)"><i class="far fa-edit"></i>
                        </b-button>
                        <b-button class="ml-2" variant="primary" v-if="Data.Durum == 0" @click="EylemiKaldir(Data),(Data.Durum = 1)">Kaldır</b-button>
                        <b-button variant="danger" v-if="Data.Durum == 2" @click="KontrollerDel(Data)">Sil
                        </b-button>
                      </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>


              </div>
            </div>
          </div>
        </div>
        <div v-if="FormData.Kontrolturu == 3  && (this.AddEdit=='Edit' || this.Kontroller == true)" class="row">
          <div class="col-md-7">

          </div>
          <div class="col-md-5">
          <b-button-group class="float-end">
            <b-button variant="success" v-b-modal.StrRisklerGirislerCevap @click="(AddEditCevap = 'Add'),(AddEditGiris = this.AddEdit)
              (GirisId = this.FormData.Id)">{{$t('StrRiskGiris.Table.EylemEkle')}}
            </b-button>
           <b-button variant="primary" v-if="this.IlkDonem==false" @click="EylemleriGetir()">Eylemleri Getir</b-button> 
          </b-button-group>
        </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <div class="card">
                <table class="table table-striped table-bordered mb-0">
                  <thead>
                    <tr>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.Eylem')}}</th>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.BaslamaTarihi')}}</th>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.BitisTarihi')}}</th>
                      <th scope="col-2" style="text-align: center;">{{$t('StrRiskGiris.Table.Islem')}}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(Data, index) in this.OnleyiciEylem" :key="index">
                    <tr  v-if="Data.Durum != 1">
                      <td scope="col-9">  {{ Data.Cevap }}</td>
                      <td scope="col-9">  {{ Data.BaslamaTarihi | formatDateTable}}</td>
                      <td scope="col-9">  {{ Data.BitisTarihi | formatDateTable}}</td>
                      <td style="text-align: center;" scope="col-3">
                        <b-button-group >
                          <b-button variant="success" v-b-modal.StrRisklerGirislerCevap @click="(AddEditCevap = 'Edit'),(EylemData = Data),(AddEditGiris = this.AddEdit),(GirisId = this.FormData.Id)"><i class="far fa-edit"></i>
                        </b-button>
                        <b-button class="ml-2" variant="primary" v-if="Data.Durum == 0" @click="EylemiKaldir(Data),(Data.Durum = 1)">Kaldır</b-button>
                        <b-button variant="danger" v-if="Data.Durum == 2" @click="KontrollerDel(Data)">Sil
                        </b-button>
                      </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-if="FormData.Kontrolturu == 4 && (this.AddEdit=='Edit' || this.Kontroller == true)" class="row">
          <div class="col-md-7">
          </div>
          <div class="col-md-5">
          <b-button-group class="float-end">
            <b-button variant="success" v-b-modal.StrRisklerGirislerCevap @click="(AddEditCevap = 'Add'),(AddEditGiris = this.AddEdit)
              (GirisId = this.FormData.Id)">{{$t('StrRiskGiris.Table.EylemEkle')}}
            </b-button>
          <b-button variant="primary" v-if="this.IlkDonem==false" @click="EylemleriGetir()">Eylemleri Getir</b-button> 
          </b-button-group>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <div class="card">
                <table class="table table-striped table-bordered mb-0">
                  <thead>
                    <tr>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.Eylem')}}</th>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.BaslamaTarihi')}}</th>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.BitisTarihi')}}</th>
                      <th scope="col-2" style="text-align: center;">{{$t('StrRiskGiris.Table.Islem')}}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(Data, index) in this.DuzelticiEylem" :key="index">
                    <tr  v-if="Data.Durum != 1">
                      <td scope="col-9">  {{ Data.Cevap }}</td>
                      <td scope="col-9">  {{ Data.BaslamaTarihi | formatDateTable}}</td>
                      <td scope="col-9">  {{ Data.BitisTarihi | formatDateTable}}</td>
                      <td style="text-align: center;" scope="col-3">
                        <b-button-group >
                          <b-button variant="success" v-b-modal.StrRisklerGirislerCevap @click="(AddEditCevap = 'Edit'),(EylemData = Data),(AddEditGiris = this.AddEdit),(GirisId = this.FormData.Id)"><i class="far fa-edit"></i>
                        </b-button>
                        <b-button class="ml-2" variant="primary" v-if="Data.Durum == 0" @click="EylemiKaldir(Data),(Data.Durum = 1)">Kaldır</b-button>
                        <b-button variant="danger" v-if="Data.Durum == 2" @click="KontrollerDel(Data)">Sil
                        </b-button>
                      </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-if="FormData.Kontrolturu == 5 && (this.AddEdit=='Edit' || this.Kontroller == true)" class="row">
          <div class="col-md-7">
          </div>
          <div class="col-md-5">
          <b-button-group class="float-end">
            <b-button variant="success" v-b-modal.StrRisklerGirislerCevap @click="(AddEditCevap = 'Add'),(AddEditGiris = this.AddEdit)
              (GirisId = this.FormData.Id)">{{$t('StrRiskGiris.Table.EylemEkle')}}
            </b-button>
        <b-button variant="primary" v-if="this.IlkDonem==false" @click="EylemleriGetir()">Eylemleri Getir</b-button> 
          </b-button-group>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <div class="card">
                <table class="table table-striped table-bordered mb-0">
                  <thead>
                    <tr>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.Eylem')}}</th>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.BaslamaTarihi')}}</th>
                      <th scope="col-10">{{$t('StrRiskGiris.Table.BitisTarihi')}}</th>
                      <th scope="col-2" style="text-align: center;">{{$t('StrRiskGiris.Table.Islem')}}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(Data, index) in this.SaptayiciEylem" :key="index">
                    <tr  v-if="Data.Durum != 1">
                      <td scope="col-9">  {{ Data.Cevap }}</td>
                      <td scope="col-9">  {{ Data.BaslamaTarihi | formatDateTable}}</td>
                      <td scope="col-9">  {{ Data.BitisTarihi | formatDateTable}}</td>
                      <td style="text-align: center;" scope="col-3">
                        <b-button-group >
                          <b-button variant="success" v-b-modal.StrRisklerGirislerCevap @click="(AddEditCevap = 'Edit'),(EylemData = Data),(AddEditGiris = this.AddEdit),(GirisId = this.FormData.Id)"><i class="far fa-edit"></i>
                        </b-button>
                        <b-button class="ml-2" variant="primary" v-if="Data.Durum == 0" @click="EylemiKaldir(Data),(Data.Durum = 1)">Kaldır</b-button>
                        <b-button variant="danger" v-if="Data.Durum == 2" @click="KontrollerDel(Data)">Sil
                        </b-button>
                      </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>


        <hr class="mt-5">

        <button class="btn btn-primary" type="submit">
          {{ $t("StrRiskGiris.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
    <AddEdit :AddEdit="AddEditCevap" :GirisId="this.FormData.Id" :Cevap="1" :KontrolTuru="FormData.Kontrolturu"
      :BirimId="this.FormData.BirimId" @TableUpdate="GetWatch()" :Data="EylemData"  />
  </Loader>
</template>
